import { render, staticRenderFns } from "./PersonDocumentKindForm.vue?vue&type=template&id=55bdb306&"
import script from "./PersonDocumentKindForm.vue?vue&type=script&lang=js&"
export * from "./PersonDocumentKindForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports